import type { LoaderFunction } from 'react-router';

import { PAGE_SIZE } from 'src/core/domain/constants';
import { getAuthStatus } from 'src/core/utils/authUtil';
import { parseThreadSlug } from 'src/core/utils/categoryUtil';
import type { Thread, Comment } from 'src/mapper/threadMapper';
import logger from 'src/modules/logger/logger';
import {
  fetchComments,
  fetchThreadDetails,
  type fetchCommentsParams,
  type fetchThreadDetailsParams,
} from 'src/services/threadsService';
import type { RouteProps } from 'src/types';

export interface ThreadDetailsModel {
  thread: Thread;
  comments: Comment[];
  init: boolean;
  isAuthenticated: boolean;
}

export const communityThreadDetailsLoader =
  ({ config, client }: RouteProps): LoaderFunction =>
  async ({ params }): Promise<ThreadDetailsModel> => {
    try {
      const isAuthenticated = await getAuthStatus();
      const { threadSlug } = params;
      if (threadSlug === undefined) {
        logger.error('threadSlug is undefined', 'communityThreadDetailsLoader');
        throw new Error('Could not find threadSlug from params', params);
      }
      const { threadId } = parseThreadSlug(threadSlug);
      const param: fetchThreadDetailsParams = {
        id: threadId,
        isAuthenticated,
        pageSize: PAGE_SIZE,
        client,
        config,
      };
      const thread: Thread = await fetchThreadDetails(param);
      const commentParams: fetchCommentsParams = {
        threadId,
        pageSize: PAGE_SIZE,
        isAuthenticated,
        cursor: 0,
        client,
        config,
      };
      const comments: Comment[] = await fetchComments(commentParams);
      return { thread, comments, init: true, isAuthenticated };
    } catch (error) {
      logger.error({ error }, 'communityThreadDetailsLoader');
      throw error;
    }
  };
